// Fonction spéciale sans génération de code JS côté client (traitement côté worker, mode "file")
export default {
  functionKey: "NB.SI COLONNE",
  title: "NB.SI COLONNE",
  group: "Calcul colonne",
  origin: [],
  multiOrigin: true,
  arguments: [],
  maxArguments: 2,
  showTypeOptions: { origin: false, target: false, arguments: false },
  requiredArguments: [
    { argumentKey: "Criterion", name: "Critère" },
    { argumentKey: "Label", name: "Libellé du résultat" }
  ],
  expectedArguments: [
    { name: "Critère", argumentKey: "Criterion", single: true, initialValue: "" },
    { name: "Libellé du résultat", argumentKey: "Label", single: true, initialValue: "Nb.si" }
  ],
  description: "Compte le nombre de valeurs égales au critère dans une ou plusieurs colonnes (lignes filtrées par les conditions).",
  details: "Compte le nombre de valeurs égales au critère dans une ou plusieurs colonnes d'origine (sur les lignes respectant les conditions du bloc — plusieurs colonnes sont combinées en un seul ensemble). Ajoute une nouvelle ligne de résultat (colonnes __fonction__ / __resultat__) sans modifier les lignes existantes.",
  isStarred: false,

  generate: null
}
